import React from 'react';
import './CTALink.css';

interface CTALinkProps {
  text: string;
  onClick?: () => void;
  href?: string;
  type?: 'primary' | 'secondary';
  color?: 'awasi' | 'off-white' | 'white';
  className?: string;
}

export const CTALink: React.FC<CTALinkProps> = ({
  text,
  onClick,
  href,
  type = 'secondary',
  color = 'awasi',
  className = ''
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      if (!href) {
        e.preventDefault();
      }
      onClick();
    }
  };

  const Element = href ? 'a' : 'button';
  const elementProps = href 
    ? { href, onClick: handleClick }
    : { type: 'button' as const, onClick: handleClick };

  return (
    <Element
      {...elementProps}
      className={`cta-link cta-link--${type} cta-link--${color} ${className}`}
    >
      <span className="cta-link__text">{text}</span>
    </Element>
  );
};